import { useUiLanguage } from "@/i18n/useUiLanguage";
import { tr } from "@/i18n/copy";
import ArtistFinancePanel from "@/components/ArtistFinancePanel";

export default function ArtistFinance() {
  useUiLanguage();
  return <main className="mx-auto max-w-5xl space-y-5">
    <header><h1 className="font-display text-3xl font-bold">{tr("Il mio rendiconto")}</h1><p className="mt-2 text-sm text-muted-foreground">{tr("Compensi personali, accordo economico e fatture del tuo rapporto con lo Studio.")}</p></header>
    <ArtistFinancePanel />
  </main>;
}
